<div class="container">
  <form name="tableItemEditForm" #tableItemEditForm="ngForm">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label for="Country"><span class="mandatory">*</span>{{'CardExternalPensionStatus.WorkedAbroadTable.Country' | translate}}</label>
          <select class="custom-select" [(ngModel)]="item.countryAbroadCode"
                  name="countryAbroadCode" #countryAbroadCode="ngModel" required nullableSelect
                 [dropdownTitle]="{value : item.countryAbroadCode, dimensions :  countries }">
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of countries" [value]="domain.code">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="countryAbroadCode"></validation-message>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label for="PayedTaxes"><span class="mandatory">*</span>{{'CardExternalPensionStatus.WorkedAbroadTable.PayedTaxes' | translate}}</label>
          <div class="btn-group btn-group-toggle" >
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0"
                   class="btn btn-toogle"
                   [class.active]="domain.value==item.hasDiscountsAbroad?.toString()" [radioLabel]="hasDiscountsAbroad">
              <input type="radio" [(ngModel)]="item.hasDiscountsAbroad" name="hasDiscountsAbroad" [value]="domain.value" #hasDiscountsAbroad="ngModel" required nullableSelect>
              {{domain.description}}
            </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </div>
      </div>

    </div>
  </form>
  <div class="d-flex justify-content-between mt-4 mb-2">
    <button type="button" class="btn btn-outline-primary disable-on-fieldset" *ngIf="!isSubmited" (click)="onRemove(isEdit)">
      <span [ngClass]="isEdit ? 'icon-trash' : 'icon-close'"></span><span>{{isEdit ?  'Remover' : 'Cancelar'}}</span>
    </button>
    <button type="button" class="btn btn-primary disable-on-fieldset" aria-label="Aplicar" *ngIf="!isSubmited" (click)="onEdit(isEdit)">
      <span class="icon-check"></span><span>Aplicar</span>
    </button>
  </div>

</div>
